<template>
  <EndorsementContract :isPolicy="true" />
</template>

<script>
import EndorsementContract from '../../components/contracts/EndorsementContract.vue';

export default {
  components: {
    EndorsementContract,
  },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.title {
  background-color: #043562 !important;
  color: white;
}
</style>
